import translations from './translations'

translations.add('es', {
    tryAgain: 'Intentar otra vez',
    failure: 'Falla'
})
